import instances from './map';
import { generateTokenLogin } from './generateToken';

export const codigoUser = cpf =>
  instances
    .wslogin({
      method: 'GET',
      url: `/login/${cpf}`
    })
    .then(response => response.data.usuarios[0]);

export const getAuth = (codigo, senha) =>
  instances
    .wslogin({
      method: 'GET',
      url: `/autenticacao`,
      headers: {
        Senha: senha,
        usuario: codigo
      }
    })
    .then(response => response.data);

export const getUser = async codigo => {
  try {
    const response = await instances.wslogin({
      method: 'GET',
      url: `/usuario/${codigo}`
    });
    if (response.data == null || response.data.descricao != null) {
      throw new Error('Problemas com o servidor. Tente novamente mais tarde.');
    }
    return response.data;

  } catch ({ message }) {
    throw new Error('Problemas com o servidor. Tente novamente mais tarde.');
  }

};

export const loginAPI = async (codigo, senha, isCpfCnpj) => {
  try {
    let usuario = { codigo: codigo, nomeUsuario: '', email: '' };
    let auth;

    auth = await generateTokenLogin(codigo, senha);
    if (auth.result != null && auth.result == "Unauthorized") {
      throw new Error('Credenciais inválidas');
    }
    return { ...auth, ...usuario };
  } catch ({ message }) {
    const errorMessage = message
      ? message
      : 'Problemas com o servidor. Tente novamente mais tarde.';

    throw new Error(errorMessage);
  }
};

export const checkTermAccept = async codigo =>
  instances
    .prestador_odonto({
      method: 'GET',
      url: `/termos-aceite`,
      params: {
        codigo_prestador: codigo
      }
    })
    .then(res => Promise.resolve(res))
    .catch(err =>
      Promise.reject(
        new Error(
          err.response.data.mensagemErro
            ? err.response.data.mensagemErro.descricao
            : 'Serviço indisponível no momento tente novamente mais tarde.'
        )
      )
    );

export default { loginAPI, checkTermAccept };
